export default {
    namespaced: true,
    state: {
        isOpen : false,
    },
    mutations: {
        toggleOpen(state) {
            state.isOpen = true;
        },
        toggleClose(state) {
            state.isOpen = false;
        }
    },
    actions: {
        toggleDrawer({commit, state}) {
            if(!state.isOpen) {
                commit('toggleOpen');
            } else {
                commit('toggleClose');
            }
        }
    }
}